/* eslint max-len: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';

class VanillaPaginatedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render() {

    var _self = this;

    var displayed_users = _self.props.displayed_users;
    
    var passed_default_page_num = _self.props.default_page_num;

    var purchased_maps = _self.props.purchased_maps;
    var handleChange = _self.props.handleChange;

    var maps = _self.props.maps;
    var user_owns;

    var default_page_num = 1;

    // function to generate wrapping divs
    // TODO: Generalize and extract this.
    function div_generator(counter, passed_function, user_owns, current_map, default_page_num, handleChange) {
      counter = counter-1;
      if (counter > 0)
      {
        return(<div>{(()=> {return(div_generator(counter, passed_function, user_owns, current_map, default_page_num, handleChange));} )()}</div>);
      }
      else
      {

        return(passed_function(user_owns, current_map, default_page_num, handleChange));
      }
    }

    // function to generate checkbox as input with desired params
    // TODO: Generalize and extract this.
    function local_function_to_pass(user_owns, current_map, default_page_num, handleChange)
      {
        return (<input type="checkbox" value={[user_owns, current_map, default_page_num]} 
          checked={user_owns} onChange={handleChange} />);
      }

    if (typeof _self.props.maps !== 'undefined' && _self.props.maps.length != 0) {

      for (var i=0; i < maps.length; i++) {

          // bug fix.
          // TODO: Generalize this functionality.

          user_owns = (purchased_maps.indexOf(maps[i]._id) !== -1) ? true : false;

          if (i >=10) 
          {
            // i am setting a flag here. 10 is representative of the table size.
            default_page_num = Math.floor(i/10)+1;
          }
          else {
            default_page_num = 1;
          }

          var current_map = maps[i]._id;

          // i am setting a flag here. 10 is representative of the table size.
          var count_down = Math.floor(i/10)+1;

          maps[i].checkbox = div_generator(count_down, local_function_to_pass, user_owns, current_map, default_page_num, _self.props.handleChange);
          
          // up to this point 

          if (Array.isArray(maps[i].cities) && maps[i].cities.length == 0){
              maps[i].cities = 'No cities affected.';
          }

          else if (maps[i].cities == 'No cities affected.') {

          }

          else if (Array.isArray(maps[i].cities)) {
              maps[i].cities = maps[i].cities.join(', ');
          }

          if (Array.isArray(maps[i].states) && maps[i].states.length == 0)
              maps[i].states = 'No states affected.';

          else if (maps[i].states == 'No states affected.') {

          }
          else if (Array.isArray(maps[i].states)) {
              maps[i].states = maps[i].states.join(', ');
          }
          
          if (moment(maps[i].storm_date, "MM/DD/YYYY", true).isValid()) {

          } 

          else {
              maps[i].storm_date =  moment(new Date(maps[i].storm_date)).format('MM/DD/YYYY');
          }
      }
    }


    function handleSearch(search_criteria, ret_val) {
      displayed_users = [];
      for (let i = 0; i < ret_val.length; i++) {
        displayed_users.push(ret_val[i]);
      }
    }


    const options_maps = {
      page: passed_default_page_num,  // which page you want to show as default
      sizePerPageList: [ 10], // you can change the dropdown list for size per page
      sizePerPage: 10,  // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 5,  // the pagination bar size.
      prePage: 'Prev', // Previous page button text
      nextPage: 'Next', // Next page button text
      firstPage: 'First', // First page button text
      lastPage: 'Last',//, // Last page button text
      //paginationShowsTotal: this.renderShowsTotal  // Accept bool or function
      hideSizePerPage: true
    };

    const options_users = {
      handleSearch : handleSearch
    };

    return (
      <div>
      {(()=> {
        if (typeof _self.props.maps !== 'undefined') {
          return (
            <BootstrapTable
              data={maps}
              pagination={true}
              search={true}
              options={options_maps}>
              <TableHeaderColumn width='6px' dataField='_id' isKey={true}>Map ID</TableHeaderColumn>
              <TableHeaderColumn width='10px' dataField='checkbox' dataFormat={f => (<div>{f}</div>)}>Owns</TableHeaderColumn>
              <TableHeaderColumn width='27px' dataField='title'>Title</TableHeaderColumn>
              <TableHeaderColumn width='27px' dataField='storm_date'>Storm Date</TableHeaderColumn>
              <TableHeaderColumn width='40px' dataField='cities'>Cities Affected</TableHeaderColumn>
              <TableHeaderColumn width='22px' dataField='states' dataFormat={f => (<div>{f}</div>)} >States Affected</TableHeaderColumn>
            </BootstrapTable>
          )
        }
        else 
        {
          return (
            <BootstrapTable
              data={displayed_users}
              pagination={true}
              search={true}
              options={options_users}>
              <TableHeaderColumn width='10%' dataField='_id' isKey={true}>ID</TableHeaderColumn>
              <TableHeaderColumn width='20%' dataField='name'>Name</TableHeaderColumn>
              <TableHeaderColumn width='10%' dataField='role'>Role</TableHeaderColumn>
              <TableHeaderColumn width='15%' dataField='company'>Company</TableHeaderColumn>
              <TableHeaderColumn width='15%' dataField='email'>Email</TableHeaderColumn>
              <TableHeaderColumn width='13%' dataField='last_login'>Last Login</TableHeaderColumn>
              <TableHeaderColumn width='10%' dataField='username'>Username</TableHeaderColumn>
              <TableHeaderColumn width='5%' dataField='edit_action' dataFormat={f => (<div>{f}</div>)}>Edit</TableHeaderColumn>
              <TableHeaderColumn width='5%' dataField='delete_action' dataFormat={f => (<div>{f}</div>)}>Delete</TableHeaderColumn>
            </BootstrapTable>
          )
        }
      })()}
      </div>
    );
  }
}

var mapStateToProps = function (state) {
  return {
    connection : state.connection,
    users : state.users
  }
}

export default connect(mapStateToProps)(VanillaPaginatedTable);



// WEBPACK FOOTER //
// ./src/browser/components/ui/vanillaPaginatedTable.js